import React from 'react';
import { useModal } from 'hooks/useModal';
import { useForm } from 'react-hook-form';
import { ModalsKeys, SelectOption } from 'global';
import { CustomDialog } from 'components/shared/Dialog';
import { Button, Stack } from '@mui/material';
import { AutocompleteField, RadioGroupField } from 'components/form';

export const sendMethodOptions: SelectOption[] = [
  { label: 'Email', value: 'email' },
  { label: 'Text', value: 'text' },
  { label: 'Email and Text', value: 'textAndEmail' },
];

export const SentProposalDialog = () => {
  const {
    isOpen,
    handleClose,
    data: { onSent, ccOptions },
  } = useModal(ModalsKeys.ProposalSentDialog);

  const { control, handleSubmit } = useForm({
    defaultValues: { sendVia: 'email', ccEmails: [] },
  });

  return (
    <CustomDialog
      maxWidth="md"
      isOpen={isOpen}
      label="Send Proposal"
      onClose={handleClose}
      actions={
        <Stack direction="row" gap="0.5rem">
          <Button onClick={handleClose}>Close</Button>

          <Button
            variant="contained"
            onClick={() => {
              handleSubmit(onSent)();
              handleClose();
            }}
          >
            Send
          </Button>
        </Stack>
      }
    >
      <Stack gap="0.5rem">
        <RadioGroupField row name="sendVia" control={control} options={sendMethodOptions} label="Send Via" />

        <AutocompleteField
          multiple
          size="small"
          name="ccEmails"
          control={control}
          options={ccOptions}
          textFieldProps={{ variant: 'outlined', label: 'CC Users' }}
        />
      </Stack>
    </CustomDialog>
  );
};
